import { makeStyles, Theme } from '@material-ui/core';

type StylesProps = {
  isExpanded?: boolean;
};

const useStyles = makeStyles((theme: Theme) => ({
  itemText: ({ isExpanded }: StylesProps) => ({
    '& > span': {
      fontWeight: isExpanded ? 700 : 'inherit',
    },
    '& .highlightedResult': {
      color: theme.palette.primary.dark,
    },
  }),
  truncated: {
    paddingRight: theme.spacing(1),
    '& > span': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
}));

export default useStyles;
